import axios from 'axios';

let API_BASE_URL = process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : 'https://node-mailer-production.up.railway.app/api');

// Fix for missing 'h' in https:// - ensure URL starts with http:// or https://
if (API_BASE_URL && !API_BASE_URL.startsWith('http://') && !API_BASE_URL.startsWith('https://')) {
  if (API_BASE_URL.startsWith('ttps://')) {
    API_BASE_URL = 'h' + API_BASE_URL;
  } else {
    // Fallback to production URL if format is invalid
    API_BASE_URL = 'https://node-mailer-production.up.railway.app/api';
  }
}

export interface OAuthTokens {
  access_token: string;
  refresh_token?: string;
  scope: string;
  token_type: string;
  expiry_date?: number;
}

export interface UserInfo {
  email: string;
  name: string;
}

export interface OAuthResponse {
  success: boolean;
  authUrl?: string;
  tokens?: OAuthTokens;
  accessToken?: string;
  userInfo?: UserInfo;
  message?: string;
  error?: string;
}

export const oauthApi = {
    // Get OAuth authorization URL
    async getAuthUrl(): Promise<OAuthResponse> {
        console.log(`[oauthApi] getAuthUrl called with API_BASE_URL: ${API_BASE_URL}`);
        try {
            const response = await axios.get<OAuthResponse>(`${API_BASE_URL}/oauth/auth-url`);
            console.log('[oauthApi] getAuthUrl response:', response.data);
            return response.data;
        } catch (error) {
            console.error('[oauthApi] Error getting auth URL:', error);
            throw error;
        }
    },

    // Test OAuth connection
    async testConnection(accessToken: string, email: string): Promise<OAuthResponse> {
        console.log(`[oauthApi] testConnection called with email: ${email}`);
        try {
            const response = await axios.post<OAuthResponse>(`${API_BASE_URL}/oauth/test-connection`, {
                accessToken,
                email
            });
            console.log('[oauthApi] testConnection response:', response.data);
            return response.data;
        } catch (error) {
            console.error('[oauthApi] Error testing OAuth connection:', error);
            throw error;
        }
    },

  // Handle OAuth callback (this will be called by the backend)
  async handleCallback(code: string): Promise<OAuthResponse> {
    try {
      const response = await axios.get<OAuthResponse>(`${API_BASE_URL}/oauth/callback?code=${code}`);
      return response.data;
    } catch (error) {
      console.error('Error handling OAuth callback:', error);
      throw error;
    }
  }
};
